import React, {useEffect, useState, useMemo} from 'react';
import CarouselIamge from '../components/CarouselImage';
import Size from '../components/Size';
import { MdShoppingBag} from 'react-icons/md';
import { useParams } from "react-router-dom";
import { getProductById } from '../store/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../store/cartSlice';
import { useNavigate } from "react-router-dom";
import {Spinner} from 'react-bootstrap';

function Product(){

   let navigate = useNavigate(); 
   const dispatch = useDispatch();
   const { product, loading, error} = useSelector( state => state.products)
   const { id } = useParams();

    const [currentImage, setCurrentImage] = useState(product?.subImages[0]);
    const [currentSize, setCurrentSize] = useState(null)
    const [quantity, setQuantity] = useState(null)

   useEffect(()=>{
      dispatch(getProductById(id))
   },[dispatch,id])

   useEffect(()=>{
        if (product?.subImages?.length > 0) {
         setCurrentImage(product.subImages[0]);
      }
   },[product])

   const sizes = useMemo(() => {
      if (!product?.sizes) return [];

      try {
         return JSON.parse(product.sizes);
      } catch (err) {
         console.error("Invalid sizes JSON:", err);
         return [];
      }
   }, [product]);

   function handleAddToCart(){
      if(currentSize == null ){
         alert("select size first")
      }else{

        dispatch(
         addToCart({
            id: product.id,
            productName: product.productName,
            price: product.price,
            image: product.mainImage,
            size: currentSize,
            quantity: 1,
            totalQuantity: quantity
         })
      )
      }
   }


   function handleSizeClick(el){
      setCurrentSize(el.size)
      setQuantity(el.quantity)
   }
 
   return(
      loading ? 
      (
               <div className='flex one center'>
                 <Spinner/>
               </div>
            ) :
    (<div className='flex one column'>
      <div className='flex two column'>
         <div className='flex four center'>
             <img src={currentImage} id='prod-img'/>
         </div>
          <div className='flex one overflow-x gap'>
           {product?.subImages && product?.subImages.length > 0 && (
            product?.subImages.map(el =>{
               return(
                   <CarouselIamge src={el} onClick={()=>{setCurrentImage(el)}}/>
               )
            })
         )}
          </div>
      </div>
       <div className='flex one column'>
         <div className='flex one'>
            <div className='flex one center'>
               <p className='special-font bold big-txt'>{product?.productName}</p>
            </div>
            <div className='flex one center'>
               <p className='bold'>ZMW {product?.price}</p>
            </div>
         </div>
         <div className='flex one center'>
            <div className='flex one center'>
               <span>Stock left</span>
            </div>
             <div className='flex one center'>
               <span>{quantity}</span>
             </div>
         </div>
         <div className='flex one center'>
            <p className='padding-10'>{product?.description}</p>
         </div>
       </div>
        <div className='flex one column'>
         <div className='flex one'>
            <div className='flex one center padding-10'>
               <p className='bold'>Select Size</p>
            </div>
            <div className='flex two'>
               {
                  sizes.map((size)=>{
                         return(
                           <Size size={size.size} currentSize={currentSize} quantity={size.quantity} onClick={() => handleSizeClick(size)}/>
                         )
                  }
               )
               }
                
            </div>
         </div>
         <div className='flex one'>
            <div className='flex one center'>
               <p className='bold'>ZMW {product?.price}</p>
            </div>
            <div className='flex two center'>
               <div className='add-cart-btn shadow orange flex' onClick={()=>{handleAddToCart()}}>
                  <div className='flex one center'>
                           <MdShoppingBag size={25} className='white-txt'/>
                  </div>
                  <div className='flex two center-align'>
                     <span className='white-txt bold small-txt'>Add To Cart</span>
                  </div>
               </div>
            </div>
         </div>
         <div className='flex one center'>
              <div className='add-cart-btn shadow orange flex center' onClick={()=>{navigate(`/cart`)}}>
                <span className='white-txt bold small-txt'>Proceed to checkout</span>
              </div>
         </div>
        </div>
    </div>)
   )
}

export default Product